<template>
  <!-- Figma UQ stepper (Equipment Info / Create Quote / Quote Summary): 40px ringed circles, done/active = blue
       filled with a white tick, upcoming = grey tick; 14px labels; thin divider underneath -->
  <div
    class="flex items-start tablet:items-center gap-[10px] tablet:gap-[20px] mb-[15px] pb-[15px] border-b border-[#EFEFEF] font-roboto"
    :class="isPartnerQuote ? 'mobile:justify-between tablet:justify-start' : 'justify-start'">
    <button v-for="tab in visibleSteps" :key="tab.state" type="button"
      :class="['group flex mobile:flex-col tablet:flex-row items-center gap-[5px] tablet:gap-[10px] p-0 border-0 bg-transparent', { active: tab.active }]"
      :aria-current="tab.active ? 'step' : null" @click="buttonClicked(tab.state)">
      <span
        class="flex items-center justify-center flex-shrink-0 w-[40px] h-[40px] rounded-full border-dashed border-[1px] border-[#CCCCCC] group-[.active]:border-[#7695FF]">
        <span
          class="flex items-center justify-center w-[26px] h-[26px] rounded-full group-[.active]:bg-[#7695FF]">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M5 12.5l4.5 4.5L19 7.5" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"
              :stroke="tab.active ? '#FFFFFF' : '#CCCCCC'" />
          </svg>
        </span>
      </span>
      <span class="text-[12px] tablet:text-[14px] whitespace-nowrap text-[#999999] group-[.active]:text-[#7695FF]">
        {{ tab.label }}
      </span>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},

  data() {
    return {
      isImages: true,
      isCreateQuote: false,
      isFinalizeQuote: false,
      step: 1,
    };
  },
  computed: {
    ...mapGetters(["quoteDetail", "componentState"]),

    isPartnerQuote() {
      return (this.quoteDetail?.partner_info?.id > 0 && this.quoteDetail?.partner_info?.status != '0') || false
    },

    // "Add Images" only exists for partner quotes (same as before)
    visibleSteps() {
      return [
        { state: "Notes", label: "Add Images", active: this.isImages, show: this.isPartnerQuote },
        { state: "QuoteItems", label: "Create Quote", active: this.isCreateQuote, show: true },
        { state: "QuoteSummary", label: "Finalize Quote", active: this.isFinalizeQuote, show: true },
      ].filter(step => step.show);
    },
  },

  watch: {
    componentState: function () {
      this.setButtons(this.componentState);
    },
  },

  mounted() {
    this.setButtons(this.componentState);
  },

  methods: {
    ...mapActions(["setCommponent"]),

    buttonClicked(stateData) {
      if (this.step == 1 && stateData == "Notes") {
        this.setCommponent(stateData);
      } else if (this.step == 2 && stateData == "Notes") {
        this.setCommponent(stateData);
      } else if (
        this.step == 3 &&
        (stateData == "Notes" || stateData == "QuoteItems")
      ) {
        this.setCommponent(stateData);
      }
    },

    setButtons(data) {
      this.resetButtons();
      if (data == "Notes") {
        this.step = 1;
        this.isImages = true;
      } else if (data == "QuoteItems") {
        this.step = 2;
        this.isImages = true;
        this.isCreateQuote = true;
      } else if (data == "QuoteSummary") {
        this.step = 3;
        this.isImages = true;
        this.isCreateQuote = true;
        this.isFinalizeQuote = true;
      }
    },
    resetButtons() {
      (this.isImages = false),
        (this.isCreateQuote = false),
        (this.isFinalizeQuote = false);
    },
  },
};
</script>